import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
// import ImagingStudyList from "../imagingstudy/List";
//import Test from "../imagingstudy/List";

function GuestLink(props) {
  let NodeServerHost = process.env.REACT_APP_API_URL;
  // let CareCode = localStorage.getItem("CareCode");
  // let OperatingId = process.env.REACT_APP_OperatingId;
  // let orgId = localStorage.getItem("orgId");

  const params = window.location.search;
  //console.log("Test")

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    (async () => {
      await fetch(NodeServerHost + `/TokenDAL`, {
        method: "POST",
      })
      .then((response) => response.json())
      .then((responseData) => {
        //console.log(responseData);
        localStorage.removeItem("AccessToken")
        localStorage.setItem("AccessTokenGuest", responseData.token)
        //return response.json(); // do something with response JSON
      });

      await fetch(NodeServerHost + `/TokenInbox`, {
        method: "POST",
      })
      .then((response) => response.json())
      .then((responseData) => {
        //console.log(responseData);
        localStorage.removeItem("AccessToken")
        localStorage.setItem("AccessTokenInbox", responseData.token)
        //return response.json(); // do something with response JSON
      });

      await fetch(NodeServerHost + `/Link`, {
        headers: {
          CareCode: "111",
          OperatingId: "111",
          LinkEncoded: params.split("?")[1],
          //Authorization: "Bearer " + AccessToken,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.json())
      .then((responseData) => {
        //console.log(responseData);
        localStorage.setItem(
          "GuestLinkValidateJson",
          JSON.stringify(responseData)
        );
      });
    })();
  }, []);

  const guestLinkJson = JSON.parse(localStorage.getItem("GuestLinkValidateJson"));
  let organizationIdGuest = guestLinkJson?.organizationId;
  let linkId = guestLinkJson?.id;

  const [message, setMessage] = useState("");

  //const [studyGuest, setStudyGuest] = useState();

  const navigate = useNavigate();


  // function GetGuestImagingStudiesList(){
  //   (async () => {
  //     await fetch(NodeServerHost + `/Link/ImagingStudy`, {
  //       headers: {
  //         OrganizationId: orgId,
  //         CareCode: CareCode,
  //         OperatingId: OperatingId,
  //         //Authorization: "Bearer " + AccessToken,
  //         "Content-Type": "application/json",
  //       },
  //     })
  //       .then((response) => response.json())
  //       .then((responseData) => {
  //         setStudyGuest(responseData);
  //         //console.log(responseData);
  //       });
  //   })();
  // }

  // useEffect(() => {
  //   GetGuestImagingStudiesList()
  // }, []);

  const onSubmit = (data) => {
    
    //console.log(data);

    fetch(NodeServerHost + `/Link/Validate`, {
      method: "POST",
      headers: {
        OrganizationId: data.OrganizationId,
        CareCode: "111",
        OperatingId: "111",
        Authorization: "Bearer " + localStorage.getItem("AccessTokenInbox"),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        linkId: data.linkId,
        password: data.password
      })
    })
    .then((response) => response.json())
    .then((responseData) => {
      console.log(responseData);
      if(responseData.msg === "Success"){
        localStorage.setItem("orgId", guestLinkJson?.organizationId)
        navigate("/ImagingStudy")
        window.location.reload(true);
        // GetGuestImagingStudiesList()
      } else if (responseData === "Invalid Credentials"){
        //alert(responseData)
        setMessage(responseData);
        setTimeout(() => {
            setMessage("")
        }, 3000)
      }
      //return responseData.json(); // do something with response JSON
    });
  };

  console.log(message);

  return (
    <div className="col-md-4 offset-4" style={{padding: "0 80px"}}>
        <div className={message !== '' ? 'alert alert-danger alert-dismissible messageinfo fade show' : 'alert alert-warning alert-dismissible fade d-none'} role="alert">
            {message}
            <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="card rounded p-4 linkdiv">
          <div className="form-group normal-password">
            <input type="hidden" name="OrganizationId" value={organizationIdGuest} {...register("OrganizationId", { required: false })}></input>
            <input type="hidden" name="linkId" value={linkId} {...register("linkId", { required: false })}></input>
            <label className="fw-bold form-label">Password</label>
            <input
              id="password"
              type="password"
              className="form-control form-control-sm"
              placeholder="Enter password"
              name="password"
              {...register("password", { required: true })}
            ></input>
            {errors.password && (
            <span className="text-danger">
                This field is required
            </span>
            )}
          </div>
          <div className="form-group d-none dob-password position-relative">
            <label className="fw-bold form-label">
              Password{" "}
              <i
                className="fa fa-question-circle"
                title="MM/DD/YYYY Format"
                data-toggle="tooltip"
              ></i>
            </label>
            <input
              id="passwordDob"
              type="text"
              className="form-control form-control-sm"
              placeholder="Select DOB"
              name="passwordDob"
              autoComplete="off"
            ></input>
            <div className="calendar-icn input-group-addon datetimepicker-addon">
              <i className="fa fa-calendar"></i>
            </div>
          </div>
          <div className="col-12 mb-2 pl-0">
            <button
              className="btn btn-primary btn-sm"
            >
              View Study
            </button>
            <div
              id="GuestSubmitLoader"
              className="spinner-border text-muted d-none form-spinner"
            ></div>
          </div>
          <div className="linkValidationJson d-none"></div>
        </div>
      </form>
      {/* <Test studies={studyGuest}></Test> */}
    </div>
  );
}

export default GuestLink;
